<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <!-- Year Filter -->
    <v-row class="justify-end">
      <v-col cols="12" sm="3" md="2">
        <v-select :items="yearList" label="Year" v-model="selectedYear" @change="onYearChange" dense solo item-text="text" item-value="value"></v-select>
      </v-col>
    </v-row>

    <div v-if="!loading">
      <v-row>
        <v-col lg="3" sm="6" md="5" cols="12">
          <v-card class="mx-1 mb-1" style="height: 130px">
            <v-card-title class="pb-3 pa-6">
              <h6>Total Referrals</h6>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pt-0 pa-6">
              <v-row no-gutters class="pb-5">
                <v-col cols="5" class="my-auto">
                  {{ referralStatistics.totalReferrals }}
                  <span class="font-weight-medium grey--text text--darken-2" style="font-size: 18px"> </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="3" sm="6" md="5" cols="12">
          <v-card class="mx-1 mb-1" style="height: 130px">
            <v-card-title class="pb-3 pa-6">
              <h6>No.of Referral by Customers</h6>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pt-0 pa-6">
              <v-row no-gutters class="pb-5">
                <v-col cols="5" class="my-auto">
                  <span class="font-weight-medium grey--text text--darken-2" style="font-size: 18px">
                    {{ referralStatistics.totalCustomerReferrals }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="3" sm="6" md="5" cols="12">
          <v-card class="mx-1 mb-1" style="height: 130px">
            <v-card-title class="pb-3 pa-6">
              <h6>No.of Referral by Employees</h6>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pt-0 pa-6">
              <v-row no-gutters class="pb-5">
                <v-col cols="5" class="my-auto">
                  <span class="font-weight-medium grey--text text--darken-2" style="font-size: 18px">
                    {{ referralStatistics.totalEmployeesReferrals }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="3" sm="6" md="5" cols="12">
          <v-card class="mx-1 mb-1" style="height: 130px">
            <v-card-title class="pb-3 pa-6">
              <h6>Total Usage</h6>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pt-0 pa-6">
              <v-row no-gutters class="pb-5">
                <v-col cols="12" class="my-auto">
                  <span class="font-weight-medium grey--text text--darken-2" style="font-size: 18px"> {{ referralStatistics.totalSubscriptionsingReferrals }} </span>
                  <span style="font-size: 12px"> Subscriptions purcahsed using referral bonus</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Monthly Referral Chart -->
      <v-row class="mt-4">
        <v-col cols="12">
          <v-card class="mx-1 mb-1">
            <v-card-text class="pt-0 pa-6">
              <ApexChart v-if="chartOptions && series" height="350" type="line" :options="chartOptions" :series="series"> </ApexChart>
              <div v-else class="text-center pa-4">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Most Referred Users and Package Distribution Charts -->
      <v-row class="mt-4">
        <v-col cols="12" md="6">
          <v-card class="mx-1 mb-1">
            <v-card-title class="pb-3 pa-6">
              <h6>Top Referred Users</h6>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pt-0 pa-6">
              <ApexChart v-if="barChartOptions && barSeries" height="400" type="bar" :options="barChartOptions" :series="barSeries"> </ApexChart>
              <div v-else class="text-center pa-4">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="mx-1 mb-1">
            <v-card-title class="pb-3 pa-6">
              <h6>Referral Credits by Package</h6>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pt-0 pa-6">
              <ApexChart v-if="pieChartOptions && pieSeries" height="400" type="pie" :options="pieChartOptions" :series="pieSeries"> </ApexChart>
              <div v-else class="text-center pa-4">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else class="text-center pa-4">
      <v-skeleton-loader type="card, card, card, card, image, image" class="mx-auto" :loading="true" height="500"></v-skeleton-loader>
    </div>
  </v-container>
</template>

<script>
import ApexChart from "vue-apexcharts";

export default {
  components: {
    ApexChart,
  },
  created() {
    if (!this.hasRole(this.AdminUserPermissions.REFERRAL_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
    this.yearList = this.getYearList();
    this.getAllReferralTransactions();
  },
  methods: {
    getYearList() {
      const currentYear = new Date().getFullYear();
      return [
        { text: currentYear.toString(), value: currentYear },
        { text: (currentYear - 1).toString(), value: currentYear - 1 },
        { text: (currentYear - 2).toString(), value: currentYear - 2 },
      ];
    },
    onYearChange() {
      this.getAllReferralTransactions();
    },
    getAllReferralTransactions() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("@/referral-transactions/api/getReferralStatistics.graphql"),
          variables: {
            year: this.selectedYear,
          },
        })
        .refetch({})
        .then(data => {
          this.referralTransactions = [];
          this.loading = false;
          if (data.data.getReferralStatistics) {
            this.referralStatistics = data.data.getReferralStatistics;
            this.setupChart();
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    setupChart() {
      if (!this.referralStatistics?.monthlyData) return;

      const monthlyData = this.referralStatistics.monthlyData;
      const categories = monthlyData.map(item => item.month);
      const data = monthlyData.map(item => item.totalCredit);

      // Line chart setup
      this.chartOptions = {
        chart: {
          id: "referral-monthly-chart",
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        title: {
          text: "Monthly Referral Credits",
          align: "left",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: categories,
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "Total Credits",
          },
        },
        colors: ["#1976d2"],
      };

      this.series = [
        {
          name: "Referral Credits",
          data: data,
        },
      ];

      // Setup other charts
      this.setupBarChart();
      this.setupPieChart();
    },
    setupBarChart() {
      if (!this.referralStatistics?.mostReferredUsers) return;

      const mostReferredUsers = this.referralStatistics.mostReferredUsers;
      const userNames = mostReferredUsers.map(item => `${item.user.firstnameEn} ${item.user.lastnameEn}`);
      const credits = mostReferredUsers.map(item => item.totalCredit);

      this.barChartOptions = {
        chart: {
          id: "most-referred-users-chart",
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: userNames,
          labels: {
            rotate: -45,
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          title: {
            text: "Total Credits",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " credits";
            },
          },
        },
        colors: ["#00E396"],
        grid: {
          borderColor: "#f1f1f1",
        },
      };

      this.barSeries = [
        {
          name: "Credits Earned",
          data: credits,
        },
      ];
    },
    setupPieChart() {
      if (!this.referralStatistics?.dataPackage) return;

      const dataPackage = this.referralStatistics.dataPackage;
      const packageNames = dataPackage.map(item => item.package.titleEn);
      const credits = dataPackage.map(item => item.totalCredit);

      this.pieChartOptions = {
        chart: {
          type: "pie",
        },
        labels: packageNames,
        colors: ["#FF4560", "#008FFB", "#00E396", "#775DD0", "#FEB019"],
        legend: {
          position: "bottom",
          horizontalAlign: "center",
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val.toFixed(1) + "%";
          },
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " credits";
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };

      this.pieSeries = credits;
    },
  },
  data() {
    return {
      referralStatistics: null,
      chartOptions: null,
      series: null,
      barChartOptions: null,
      barSeries: null,
      pieChartOptions: null,
      pieSeries: null,
      loading: false,
      selectedYear: new Date().getFullYear(),
      yearList: [],
    };
  },
};
</script>
<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
